import React, { Component } from 'react';
import BACKEND_URL from '../../config';

class ReviewCard extends Component {
    constructor(props, context) {
      super(props, context);
        this.state = {
          review: {}
        };
    }
    componentDidMount() {
      fetch(`${BACKEND_URL}/reviews/${this.props.match.params.id}`)
        .then(res => res.json())
        .then(review => {
          return this.setState({ review: review[0] })});
          
    } 
  
    render() {
      return (
        <article>
            <div to="" className="link dt w-100 bb b--black-10 pb2 mt2 blue">
              <div className="dtc v-top pl2">
                <h1 className="f6 f5-ns fw6 lh-title black mv0">
                  Review for {this.state.review.employee_id} by {this.state.review.reviewer_id}
                </h1>
                <div className="f6 mt2 mb0 black-60">
                  <ul className="list pl0 ml0 center ba b--light-silver br3">
                    <li className="ph3 pv2 bb b--light-silver">
                      <h3 className="f5 bg-near-white br3 br--top black-60 mv0 pv2 ph3">
                        Comments
                      </h3>
                      <div className="pa3 bt b--black-10">
                        <p className="f6 f5-ns lh-copy measure">
                        {this.state.review.comments}
                        </p>
                      </div>
                    </li>
                    <li className="ph3 pv2 bb b--light-silver">
                      <h3 className="f5 bg-near-white br3 br--top black-60 mv0 pv2 ph3">
                        Wins
                      </h3>
                      <div className="pa3 bt b--black-10">
                        <p className="f6 f5-ns lh-copy measure">
                        {this.state.review.wins}
                        </p>
                      </div>
                    </li>
                    <li className="ph3 pv2 bb b--light-silver">
                      <h3 className="f5 bg-near-white br3 br--top black-60 mv0 pv2 ph3">
                        Opportunities
                      </h3>
                      <div className="pa3 bt b--black-10">
                        <p className="f6 f5-ns lh-copy measure">
                          {this.state.review.opportunities}
                        </p>
                      </div>
                    </li>
                  </ul>         
                </div>
                <dl className={this.state.review.requires_feedback ? 'mt2 f6': 'dn'}>
                  <dd className="ml0">
                    Requires feedback
                  </dd>
                </dl>
              </div>
            </div>
          </article>
      );
    }
  }

  export default ReviewCard;


// WEBPACK FOOTER //
// ./src/components/review/ReviewCard.js